<script setup lang="ts">
import { list } from './ShortcutData'
import { t } from '@/i18n'
</script>

<template>
  <div v-for="section in list" :key="section.sectionHeader" class="mb-6">
    <h2 class="text-lg font-bold">
      {{ section.sectionHeader }}
    </h2>
    <p v-if="section.sectionSubHeader" class="mb-4">
      {{ section.sectionSubHeader }}
    </p>
    <ul class="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <li v-for="(shortcut, index) in section.shortcuts" :key="index" class="flex items-center">
        <div class="flex flex-row min-w-28">
          <span v-for="(key, keyIndex) in shortcut.keys" :key="keyIndex" class="flex items-center">
            <kbd
              class="min-h-7.5 inline-flex justify-center items-center py-1 px-1.5 bg-white border border-gray-200 font-mono text-sm text-gray-800 shadow-[0px_2px_0px_0px_rgba(0,0,0,0.08)] rounded-md"
            >
              {{ key }}
            </kbd>
            <span v-if="!shortcut.noPlus && keyIndex < shortcut.keys.length - 1" class="mx-2">
              {{ t('general.Plus') }}
            </span>
            <span v-else-if="keyIndex < shortcut.keys.length - 1" class="mr-2 ml-1">
              {{ t('general.Komma') }}
            </span>
          </span>
        </div>
        <span class="align-bottom">{{ shortcut.description }}</span>
      </li>
    </ul>
  </div>
</template>
